import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  CardMedia,
  Grid,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";

import imageExample6 from "assets/images/turkPipelinesImages/0-xMaFF2hSXpf_kIfG.jpeg";
import imageExample4 from "assets/images/turkPipelinesImages/783px-Test-Logo.svg.png";
import imageExample3 from "assets/images/turkPipelinesImages/avatar.jpeg";
import imageExample2 from "assets/images/turkPipelinesImages/road-sign-361513_960_720.jpeg";
import imageExample5 from "assets/images/turkPipelinesImages/test-intelligenza-sociale.jpeg";
import imageExample1 from "assets/images/turkPipelinesImages/Top-25-API-Testing-Tools.png";
import { useAppDialog } from "hooks/useAppDialog";
import { BeforeAfterCard } from "./Cards/BeforeAfterCard";

export interface BeforeAfter {
  beforeImgUrl: string;
  afterImgUrl: string;
  status: string;
}

export const BeforeAfterClaim = (): JSX.Element => {
  const { t } = useTranslation();
  const { openDialog, Dialog, dialogProps } = useAppDialog();
  const [selectedImageUrl, setSelectedImageUrl] = useState("");
  // TODO: replace values with values from Api when it is available
  const instructionsText =
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla metus justo, accumsan vel turpis ac, vulputate suscipit dui. Quisque quis risus venenatis felis cursus mattis. Duis tortor diam, dictum eu viverra vitae, suscipit et risus. Sed in pellentesque erat, et auctor lectus. Ut dignissim tortor egestas nulla vulputate, in dapibus magna fermentum. Nulla varius elit non magna mollis sagittis. Nulla suscipit tellus non nisi tristique condimentum. Nunc et tellus in tellus semper sollicitudin quis eu velit. Etiam vitae venenatis nibh, quis molestie leo. Donec a tincidunt dui. Quisque commodo magna in fringilla maximus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum turpis lacus, accumsan id magna vitae, malesuada feugiat ex. Aenean rutrum pharetra dolor, dapibus ultricies ex dapibus nec. Phasellus iaculis ante at sem accumsan dapibus. Sed ornare nulla vel tortor luctus pretium. Mauris et eros nec tortor feugiat malesuada faucibus ut lacus. In id tortor interdum, condimentum felis a, pellentesque orci. Vestibulum luctus egestas metus. Nunc vitae suscipit tellus. Cras dapibus enim eget nulla volutpat tristique. Maecenas non arcu nec erat sagittis aliquet ac ac lorem. Nunc interdum ornare pulvinar. Donec eu mi auctor, pharetra libero eu, eleifend lorem. Fusce id felis malesuada, ullamcorper neque sed, eleifend nunc. Nam tempus bibendum ex, vitae blandit libero venenatis at. Morbi in dapibus orci, at fermentum mauris. Nunc tincidunt mi ut gravida viverra. Nulla facilisi. Duis elementum, justo quis condimentum pharetra, metus erat varius lacus, nec blandit leo erat nec justo. Mauris vulputate diam ac mi hendrerit, at tempus tortor porta. Quisque tristique elit non dolor convallis elementum sit amet vel felis. Ut erat risus, eleifend eu ornare sit amet, euismod ut ipsum. Donec lobortis suscipit quam in pretium. Donec tristique odio vitae dolor viverra, egestas vehicula metus consectetur. Fusce tempor eget elit sit amet iaculis. Suspendisse lobortis cursus eros, eleifend porttitor tortor pulvinar ac. Integer venenatis rutrum lectus, et bibendum lacus elementum at. Nullam in euismod purus. Morbi convallis, lorem eu rhoncus venenatis, magna augue mattis est, sed congue erat ex nec tortor. Quisque non pharetra tellus, sit amet interdum turpis. Nunc eleifend turpis elementum ipsum rutrum feugiat. Duis auctor eu nulla vel fringilla. Nulla tincidunt posuere lorem sed bibendum.";
  const imageArray: Array<BeforeAfter> = [
    {
      beforeImgUrl: imageExample1,
      afterImgUrl: imageExample2,
      status: "noDifferences",
    },
    {
      beforeImgUrl: imageExample4,
      afterImgUrl: imageExample5,
      status: "noDifferences",
    },
    {
      beforeImgUrl: imageExample6,
      afterImgUrl: imageExample3,
      status: "noDifferences",
    },
    {
      beforeImgUrl: imageExample1,
      afterImgUrl: imageExample4,
      status: "noDifferences",
    },
  ];

  const onBeforeAfterClick = useCallback(
    (selectedImageUrl: string) => {
      setSelectedImageUrl(selectedImageUrl);
      openDialog();
    },
    [openDialog]
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={9} sx={{ overflow: "auto", height: "100%" }}>
        <Grid container spacing={3} sx={{ pr: "2px", pb: 2 }}>
          {imageArray.map((image, index) => (
            <Grid key={index} item xs={10}>
              <BeforeAfterCard
                renderImage={image}
                minStatusSelectWidth={250}
                sx={{ maxWidth: 800, maxHeight: 400 }}
                sxCardMediaProps={{ minHeight: 250, maxHeight: 250 }}
                index={index}
                onImageClick={onBeforeAfterClick}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid item xs={3} sx={{ overflow: "hidden", height: "100%" }}>
        <Stack sx={{ maxHeight: "100%" }}>
          <Tabs value="Instructions">
            <Tab label={t("Instructions")} value="Instructions" />
          </Tabs>
          <Box sx={{ overflow: "auto" }}>
            <Typography variant="body1" p={1}>
              {instructionsText}
            </Typography>
          </Box>
          <Stack spacing={2} paddingY={2}>
            <Button variant="contained" size="large" disableElevation>
              {t("CompleteJob")}
            </Button>
            <Button>{t("UnclaimJob")}</Button>
          </Stack>
        </Stack>
      </Grid>
      <Dialog
        {...dialogProps}
        title={t("BeforeAfter")}
        loading={false}
        onSubmit={() => null}
        renderActions={false}
        actionText={t("Save")}
        maxWidth="md"
      >
        <CardMedia
          component="img"
          image={selectedImageUrl}
          alt={"before-after-selected-image"}
          sx={{ minHeight: 500, maxHeight: 500 }}
        />
      </Dialog>
    </Grid>
  );
};
